var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _g, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGirl2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1300,
    height: 1300,
    viewBox: "0 0 1300 1300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M650 1300C290.71 1300 0 1008.86 0 650C0 290.71 291.141 0 650 0C1009.29 0 1300 291.141 1300 650C1300.43 1009.29 1009.29 1300 650 1300Z",
    fill: "#ABD0CB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_32_1392",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1301,
    height: 1300
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M650 1300C290.71 1300 0 1008.86 0 650C0 290.71 291.141 0 650 0C1009.29 0 1300 291.141 1300 650C1300.43 1009.29 1009.29 1300 650 1300Z",
    fill: "#F7C0B5"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_32_1392)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1014 1197.33C1010.97 1199.5 1007.5 1201.66 1004.47 1203.83C1001 1206 997.967 1208.16 994.5 1209.9C991.467 1211.63 988.867 1213.36 985.834 1215.1C985.4 1215.53 984.967 1215.53 984.534 1215.96C974.567 1222.03 964.167 1227.66 953.767 1232.86C950.734 1234.6 947.267 1236.33 944.234 1237.63C944.234 1237.63 943.8 1238.06 943.367 1238.06C939.9 1239.8 936.434 1241.53 932.967 1243.26C926.034 1246.73 918.667 1249.76 911.734 1252.8C908.267 1254.53 904.367 1255.83 900.9 1257.13C897.434 1258.43 893.534 1260.16 890.067 1261.46C886.6 1262.76 882.7 1264.5 879.234 1265.8C879.234 1265.8 879.234 1265.8 878.8 1265.8C875.334 1267.1 871.434 1268.4 867.967 1269.7C860.167 1272.3 851.934 1274.9 844.134 1277.5C841.534 1278.36 838.5 1279.23 835.9 1280.1C827.667 1282.7 819.434 1284.86 811.2 1286.6C808.167 1287.46 805.134 1287.9 801.667 1288.76C793.867 1290.5 785.634 1292.23 777.834 1293.96C776.1 1294.4 774.8 1294.4 773.067 1294.83C770.467 1295.26 767.434 1295.7 764.834 1296.13C760.934 1296.56 757.467 1297.43 753.567 1297.86C751.834 1298.3 750.1 1298.3 748.367 1298.73C746.2 1299.16 743.6 1299.6 741 1299.6C734.067 1300.46 726.7 1301.33 719.767 1302.2C717.6 1302.63 715 1302.63 712.834 1303.06H712.4C709.367 1303.5 706.334 1303.5 703.3 1303.93C700.267 1304.36 697.234 1304.36 694.2 1304.36C692.467 1304.36 690.3 1304.8 688.567 1304.8C685.1 1304.8 682.067 1305.23 679.034 1305.23C674.7 1305.23 670.8 1305.66 666.467 1305.66C662.134 1305.66 658.234 1305.66 653.9 1305.66C650.867 1305.66 647.834 1305.66 644.8 1305.66C462.367 1303.06 297.7 1225.5 180.7 1102.43C180.7 1102.43 180.7 1102 180.267 1102C193.7 1075.56 243.534 1027.9 295.534 988.465C361.4 938.632 454.567 907.865 454.567 907.865C454.567 907.865 515.667 897.898 742.3 945.132C915.2 981.532 988.867 1129.3 1014 1197.33Z",
    fill: "#F7D3B5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M790.4 1065.17C781.3 1109.8 722.367 1136.23 623.134 1096.37C501.367 1046.97 454.567 907.865 454.567 907.865C448.067 808.199 432.9 722.832 432.9 722.832C573.734 710.699 740.134 875.365 740.134 875.365L759.2 956.832C760.934 963.765 764.4 969.832 769.6 974.165C778.7 989.765 796.467 1036.57 790.4 1065.17Z",
    fill: "#F7D3B5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M769.6 974.598C686.834 970.265 625.734 958.132 560.3 840.698C615.767 889.665 681.2 908.298 750.1 916.965L759.2 956.832C760.934 964.198 764.4 970.265 769.6 974.598Z",
    fill: "#EFBDA5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M940.767 452.432C948.567 488.832 952.467 518.298 931.234 615.365C910 712.432 950.734 809.498 848.467 898.332C779.567 958.132 659.1 969.398 562.9 903.965C530.4 881.865 500.5 851.098 476.234 810.798C457.167 779.165 435.067 749.265 410.367 721.965C376.134 684.698 334.967 609.732 355.334 477.132C388.267 261.332 601.9 236.632 728 260.465C854.1 284.298 919.534 356.232 940.767 452.432Z",
    fill: "#F7D3B5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M526.067 621.865C526.067 621.865 512.634 556.865 449.367 564.665C394.767 571.598 375.701 702.465 499.634 738.865",
    fill: "#F7D3B5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M495.734 679.498C495.734 679.498 480.134 669.532 481.867 652.198C484.467 631.832 481.867 619.265 472.334 615.365C448.5 605.398 443.734 633.132 444.6 636.598",
    stroke: "#423232",
    strokeWidth: 13.4786,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M826.367 721.532C826.367 721.532 842.833 722.398 858.433 703.765C867.1 693.365 874.467 680.365 869.7 676.465C864.933 672.132 786.5 684.265 781.3 694.665C776.1 705.065 806.433 721.532 826.367 721.532Z",
    fill: "#EFBDA5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M839.367 575.932C839.367 575.932 840.233 617.098 866.666 663.032C878.366 683.398 860.6 716.765 822.033 722.398",
    stroke: "#423232",
    strokeWidth: 13.4786,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M604.501 743.632C629.151 743.632 649.134 727.141 649.134 706.798C649.134 686.456 629.151 669.965 604.501 669.965C579.85 669.965 559.867 686.456 559.867 706.798C559.867 727.141 579.85 743.632 604.501 743.632Z",
    fill: "#ED938A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M924.3 670.832C923 695.098 923.434 718.932 921.7 742.765C902.634 738.432 888.767 724.132 888.767 707.232C888.767 689.032 903.934 674.298 924.3 670.832Z",
    fill: "#ED938A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M780.52 936C780.52 936 715.52 955.067 625.386 925.6C535.253 896.133 447.286 818.567 447.286 818.567C447.286 818.567 418.686 819 407.853 840.667C397.453 862.333 397.886 906.967 381.42 919.1C377.52 921.7 366.686 924.733 350.653 929.067C324.653 936.433 286.086 947.7 247.086 969.8C218.053 986.267 188.586 1008.37 163.886 1038.7C152.62 1052.57 142.653 1068.17 133.986 1085.93C65.5197 1225.03 94.9863 1420.03 94.9863 1420.03H1154.05C1154.05 1420.03 1123.29 1179.1 1056.99 1099.8C990.686 1020.5 864.153 956.367 826.886 939.467V914.333C827.32 914.333 804.353 929.5 780.52 936Z",
    fill: "#48D89E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_32_1392",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 88,
    y: 818,
    width: 1067,
    height: 603
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M780.52 936C780.52 936 715.52 955.067 625.386 925.6C535.253 896.133 447.286 818.567 447.286 818.567C447.286 818.567 418.686 819 407.853 840.667C397.453 862.333 397.886 906.967 381.42 919.1C377.52 921.7 366.686 924.733 350.653 929.067C324.653 936.433 286.086 947.7 247.086 969.8C218.053 986.267 188.586 1008.37 163.886 1038.7C152.62 1052.57 142.653 1068.17 133.986 1085.93C65.5197 1225.03 94.9863 1420.03 94.9863 1420.03H1154.05C1154.05 1420.03 1123.29 1179.1 1056.99 1099.8C990.686 1020.5 864.153 956.367 826.886 939.467V914.333C827.32 914.333 804.353 929.5 780.52 936Z",
    fill: "#48D89E"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_32_1392)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M265.72 1101.53C291.088 1101.53 311.653 1080.97 311.653 1055.6C311.653 1030.23 291.088 1009.67 265.72 1009.67C240.351 1009.67 219.786 1030.23 219.786 1055.6C219.786 1080.97 240.351 1101.53 265.72 1101.53Z",
    fill: "#FCED7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.02 1080.3C552.388 1080.3 572.953 1059.73 572.953 1034.37C572.953 1009 552.388 988.433 527.02 988.433C501.652 988.433 481.087 1009 481.087 1034.37C481.087 1059.73 501.652 1080.3 527.02 1080.3Z",
    fill: "#FCED7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M724.62 982.8C749.988 982.8 770.553 962.235 770.553 936.867C770.553 911.499 749.988 890.933 724.62 890.933C699.252 890.933 678.687 911.499 678.687 936.867C678.687 962.235 699.252 982.8 724.62 982.8Z",
    fill: "#FCED7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.553 1305.2C470.922 1305.2 491.487 1284.64 491.487 1259.27C491.487 1233.9 470.922 1213.33 445.553 1213.33C420.185 1213.33 399.62 1233.9 399.62 1259.27C399.62 1284.64 420.185 1305.2 445.553 1305.2Z",
    fill: "#FCED7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M980.287 1281.8C1005.66 1281.8 1026.22 1261.24 1026.22 1235.87C1026.22 1210.5 1005.66 1189.93 980.287 1189.93C954.919 1189.93 934.354 1210.5 934.354 1235.87C934.354 1261.24 954.919 1281.8 980.287 1281.8Z",
    fill: "#FCED7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M727.219 1244.53C752.588 1244.53 773.153 1223.97 773.153 1198.6C773.153 1173.23 752.588 1152.67 727.219 1152.67C701.851 1152.67 681.286 1173.23 681.286 1198.6C681.286 1223.97 701.851 1244.53 727.219 1244.53Z",
    fill: "#FCED7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M944.753 1058.2C970.121 1058.2 990.686 1037.63 990.686 1012.27C990.686 986.898 970.121 966.333 944.753 966.333C919.384 966.333 898.819 986.898 898.819 1012.27C898.819 1037.63 919.384 1058.2 944.753 1058.2Z",
    fill: "#FCED7E"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M827.321 939.467C827.321 939.467 832.954 978.467 822.988 1000.57C806.954 1036.97 695.588 1078.57 560.821 1030.03C453.788 991.467 401.354 938.167 400.054 929.933",
    stroke: "#329369",
    strokeWidth: 13.4786,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M481.087 862.767C478.921 865.367 476.754 868.834 475.021 873.167C468.954 887.9 467.221 918.667 467.221 918.667",
    stroke: "#329369",
    strokeWidth: 13.4786,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M554.321 907.4C552.587 910.867 550.854 914.767 549.987 919.1C547.821 930.367 545.221 965.9 545.221 965.9",
    stroke: "#329369",
    strokeWidth: 13.4786,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M627.988 937.733C627.121 941.2 626.254 945.533 625.821 950.733C624.954 956.8 625.388 993.633 625.388 993.633",
    stroke: "#329369",
    strokeWidth: 13.4786,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M706.854 955.067C707.721 965.033 708.154 978.9 706.854 995.8",
    stroke: "#329369",
    strokeWidth: 13.4786,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M773.155 951.6C774.455 959.834 775.755 971.1 776.188 985.4",
    stroke: "#329369",
    strokeWidth: 13.4786,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M433.854 820.3C423.454 824.2 409.588 834.6 404.388 864.934",
    stroke: "#329369",
    strokeWidth: 13.4786,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M878.454 965.034C856.354 952.9 838.154 944.233 827.32 939.467V914.333",
    stroke: "#329369",
    strokeWidth: 13.4786,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M745.802 526.549C755.216 527.849 762.49 517.882 759.067 508.349C757.355 503.149 754.36 498.382 749.653 495.349C735.104 486.249 680.758 485.382 652.088 506.182C626.841 525.249 703.01 520.482 745.802 526.549Z",
    fill: "#423232"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M864.333 531.315C856.63 531.315 851.923 521.349 855.775 513.115C857.914 508.782 860.91 504.882 865.189 502.716C878.454 496.215 913.971 500.116 929.804 522.216C943.925 541.716 899.85 530.882 864.333 531.315Z",
    fill: "#423232"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M730.824 581.149C703.437 567.282 660.217 577.683 660.217 577.683",
    stroke: "#423232",
    strokeWidth: 13.4786,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M899.853 589.816C899.853 589.816 888.727 577.683 847.647 587.216",
    stroke: "#423232",
    strokeWidth: 13.4786,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M816.925 774.866C805.693 779.808 800.301 769.924 782.779 778.46C770.199 784.301 763.46 786.098 748.184 777.112C738.299 770.822 726.169 779.808 714.487 762.735",
    stroke: "#423232",
    strokeWidth: 13.4786,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M1052.43 935.089C1028.17 881.355 1009.53 888.722 1026.43 840.189C1043.33 792.089 1021.67 757.855 977.034 712.355C934.567 669.022 930.234 621.789 931.534 614.855C927.634 633.055 925.901 651.689 925.034 669.889C923.734 694.155 924.167 717.989 922.434 741.822C918.967 795.122 906.401 847.555 849.201 896.955C824.067 918.622 792.001 934.222 756.467 941.589C746.934 970.622 761.234 991.422 792.434 994.889C823.634 998.355 836.634 1045.16 907.267 1067.26C1013 1101.49 1076.7 988.822 1052.43 935.089Z",
    fill: "#423232"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M854.834 410.756C863.934 415.522 871.734 411.189 876.501 401.656C926.768 393.856 938.468 494.389 940.201 500.456C941.934 506.956 942.801 525.156 939.334 574.989C937.168 602.722 1098.37 405.989 951.034 322.789C961.868 306.756 954.068 227.022 863.501 207.522C831.001 200.589 788.534 230.922 735.234 219.222C526.801 172.856 310.568 217.056 327.468 492.222C331.368 552.456 335.268 617.456 233.001 660.789C114.268 711.056 120.334 842.356 203.968 869.222C238.634 880.489 124.234 958.489 190.968 1027.82C225.634 1064.22 287.601 990.556 350.434 1030.42C445.334 1090.66 492.568 1063.36 511.201 1039.52C549.334 990.989 502.101 893.489 502.101 893.489C502.101 893.489 520.734 863.589 526.801 847.556C556.268 768.689 486.068 733.156 486.068 733.156C377.734 691.556 397.234 570.656 450.101 563.722C505.568 556.789 522.901 606.189 525.934 618.322C525.934 618.322 574.901 685.922 669.368 531.656C762.968 377.389 814.101 388.656 854.834 410.756Z",
    fill: "#423232"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M467.544 705.467V779.134",
    stroke: "#FFDE55",
    strokeWidth: 13.4786,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M526.044 877.934C514.344 889.634 498.311 897 480.111 897C445.011 897 415.978 868.4 415.978 832.867C415.978 797.767 444.578 768.734 480.111 768.734C497.878 768.734 514.344 776.1 526.044 787.8C518.244 783.467 509.578 780.867 500.044 780.867C471.444 780.867 448.044 804.267 448.044 832.867C448.044 861.467 471.444 884.867 500.044 884.867C509.578 885.3 518.244 882.7 526.044 877.934Z",
    fill: "#FFDE55"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M467.544 858.867C481.664 858.867 493.111 847.42 493.111 833.3C493.111 819.18 481.664 807.734 467.544 807.734C453.424 807.734 441.978 819.18 441.978 833.3C441.978 847.42 453.424 858.867 467.544 858.867Z",
    fill: "#FF6B57"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M961.978 788.667C954.178 784.334 945.512 781.734 935.978 781.734C929.045 781.734 922.978 783.034 916.912 785.634C917.778 780.434 919.078 775.234 919.512 770.034C936.412 770.467 951.145 777.401 961.978 788.667Z",
    fill: "#FFDE55"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M962.411 877.934C950.711 889.634 934.677 897 916.477 897C898.277 897 881.377 889.2 869.677 876.634C876.611 868.834 882.677 861.034 888.311 853.234C896.111 871.867 914.744 884.434 935.977 884.434C945.511 885.3 954.611 882.7 962.411 877.934Z",
    fill: "#FFDE55"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M929.478 833.301C929.478 847.601 918.211 858.867 903.911 858.867C898.278 858.867 893.078 857.134 888.745 853.667C898.711 838.934 906.078 823.767 910.845 809.034C921.245 811.634 929.478 821.601 929.478 833.301Z",
    fill: "#FF6B57"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGirl2);
export default __webpack_public_path__ + "static/media/Girl_2.c18adf0ec87f0d2978672bc0cc144e1e.svg";
export { ForwardRef as ReactComponent };